import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { customBearerTokenInterceptor } from '@inoventoryapps/keycloak-angular';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.routes';
import { debugInterceptor } from './interceptors/debug/debug-interceptor';
import { encryptionInterceptor } from './interceptors/encryption/encryption-interceptor';
import { headerInterceptor } from './interceptors/header/header-interceptor';
import { loaderInterceptor } from './interceptors/loader/loader-interceptor';
import { provideKeycloakConfig } from './providers/keycloak.provider';
import { KeyService } from './services/key/key.service';
import { ThemeService } from './services/theme/theme-service';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
        provideHttpClient(
            withInterceptors([
                debugInterceptor,
                customBearerTokenInterceptor,
                loaderInterceptor,
                encryptionInterceptor,
                headerInterceptor,
            ]),
        ),
        ...provideKeycloakConfig(),
        provideAppInitializer(() => {
            const keyService = inject(KeyService);
            return keyService.initDB();
        }),
        provideTranslateService({
            loader: provideTranslateHttpLoader({
                prefix: '/i18n/',
                suffix: '.json',
                // Translations are same-origin static files. Going through HttpBackend
                // bypasses the interceptor chain, so a token refresh or an unreachable
                // JWKS host can never stop the UI from loading its strings.
                useHttpBackend: true,
            }),
            fallbackLang: 'en',
            lang: 'en',
        }),
        provideAppInitializer(async () => {
            await inject(ThemeService).initialize();
        }),
    ],
};
